var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { tradeoffs, property, distance, ctaText } = options; 
__p+='\n';
 let ctaText_submit = "Contact Agent" 
__p+='\n';
 if(ctaText == 'V1') { 
__p+='\n  ';
 ctaText_submit = "Contact an Agent" 
__p+='\n';
 } 
__p+='\n\n<div class="consider-homes-properties">\n  <p class="ldp-sub-title-section">\n    ';
 if (distance) { 
__p+='\n      Properties within '+
((__t=( distance.round() ))==null?'':__t)+
' miles from '+
((__t=( property.address_display ))==null?'':__t)+
'\n    ';
 } else { 
__p+='\n      Properties near '+
((__t=( property.address_display ))==null?'':__t)+
'\n    ';
 } 
__p+='\n  </p>\n  <div class="consider-home-container">\n    <div class="consider-home-tabs">\n      <ul>\n        ';
 let activeTab = true 
__p+='\n        ';
 for (let key in tradeoffs) { 
__p+='\n          ';
 if (tradeoffs[key].length >= 5) { 
__p+='\n            <li data-name="'+
((__t=( key ))==null?'':__t)+
'" class="';
 if (activeTab) { 
__p+='active-tab';
 } 
__p+='" data-omtag="ldp:similar-homes:tradeoff:'+
((__t=( key.replace(/_/g, '-') ))==null?'':__t)+
'">\n              '+
((__t=( key.split('_').map((word) => word.capitalize()).join(' ') ))==null?'':__t)+
'\n            </li>\n            ';
 activeTab = false 
__p+='\n          ';
 } 
__p+='\n        ';
 } 
__p+='\n      </ul>\n    </div>\n    <div class="consider-properties-wrapper">\n      ';
 for (var key in tradeoffs) { 
__p+='\n        ';
 if (tradeoffs[key].length >= 5) { 
__p+='\n          <div class="consider-properties-container" id="'+
((__t=( key ))==null?'':__t)+
'-container">\n            <div class="content">\n              ';
 tradeoffs[key].forEach((tradeoff) => { 
__p+='\n                '+
((__t=( JST["quick_view/templates/consider-home/browse-module-card"]({tradeoff, key, property}) ))==null?'':__t)+
'\n              ';
 }) 
__p+='\n            </div>\n          </div>\n        ';
 } 
__p+='\n      ';
 } 
__p+='\n    </div>\n    <div class="margin-top-lg margin-bottom-lg ldp-section-ctas text-center" id="ldp-comparable-section-cta">\n      <span class="font-bold">Interested in any of these homes?</span>\n      <div class=\'visible-xxs-block margin-top\'></div>\n      <a href="javascript:void(0)" data-title="Ask a neighborhood expert" class="js-qv-contact-agent btn btn-primary margin-left-lg round-cta" data-omtag="ldp:similar-homes:contact-agent" data-placeholder="I would like more information about this neighborhood." data-formid="secondary">\n        '+
((__t=( ctaText_submit ))==null?'':__t)+
'\n      </a>\n    </div>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/consider-home/properties.jst.ejs